<template>
  <div>
    <!--begin::Dashboard-->
    <div class="row">
      <div class="col-xxl-4">
        <DaftarTertunda :dataSiswa="dataSiswa"></DaftarTertunda>
      </div>
    </div>
    <!--end::Dashboard-->
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import DaftarTertunda from "@/view/content/widgets/custom/DaftarTertunda.vue";
import axios from "axios";

export default {
  name: "tertunda",
  components: {
    DaftarTertunda
  },
  data() {
    return {
      baseUrl: "https://backend-siradi2.azurewebsites.net",
      apiURL: "https://backend-siradi2.azurewebsites.net/guru",
      dataSiswa: [],
      tingkat: "XI"
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Dashboard" }]);
    this.fetchKelas();
  },
  methods: {
    fetchKelas() {
      return axios.get(this.apiURL + "/tertunda").then(response => {
        this.dataSiswa = response.data;
        this.dataSiswa = this.dataSiswa.sort(function(x, y) {
          let a = x.kelas.label.toUpperCase(),
            b = y.kelas.label.toUpperCase();
          return a == b ? 0 : a > b ? 1 : -1;
        });
      });
    }
  }
};
</script>
